import React, { Fragment } from "react";

const researchLicenceInfo = () => {
  return (
    <Fragment>
      Any project organised for non-commercial research purposes only. A necessary condition for the recognition of
      non-commercial purposes is that all the results obtained are openly available at delivery costs only, without any
      delay linked to commercial objectives, and that the research itself is submitted for open publication. Please note
      that the licence is subject to management approval.
    </Fragment>
  )
}

const researchProjectFeeWaiverInfo = () => {
  return (
    <Fragment>
      Any project organised for non-commercial research purposes only. A necessary condition for the recognition of
      non-commercial purposes is that all the results obtained are openly available at delivery costs only, without any
      delay linked to commercial objectives, and that the research itself is submitted for open publication. Please note
      that the Research Project Fee-Waiver Service Agreement is subject to management approval. The cost shown is the
      indicative cost in the event that the Fee Waiver is not approved.
    </Fragment>
  )
}

const HelpTexts = {
  researchLicenceInfo,
  researchProjectFeeWaiverInfo
};

export default HelpTexts;
